import { App } from "vue";

export default {
  install(app: App): void {
    app.config.globalProperties.$setSafeInterval = (
      func: () => void,
      intervalMilliSec: number
    ): number => {
      return window.setInterval(func, intervalMilliSec);
    };
  },
};
